<script setup>
import { computed } from 'vue'

const props = defineProps({
  variant: {
    type: String,
    default: 'default',
    validator: value => ['default', 'light', 'dark'].includes(value),
  },
  height: {
    type: [Number, String],
    default: 26,
  },
})

const variantPaths = {
  default: '/brand/logotype_4_red.svg',
  light: '/brand/logotype_4_white.svg',
  dark: '/brand/logotype_4_black.svg',
}

const logoSrc = computed(() => {
  return variantPaths[props.variant] || variantPaths.default
})
</script>

<template>
  <RouterLink to="/" class="">
    <img :src="logoSrc" :style="{ maxHeight: `${height}px` }" alt="Selfwise">
  </RouterLink>
</template>
